import "./stylesheet/main.css";
import ProjectE from "./ProjectE/ProjectE.js";
window.onload = () => {
  fetch("./Dataset/site_config.json").then(function(response) {
    return response.json();
  }).then(function(myJson) {
    let projectEDemo = new ProjectE(myJson);
  });
};
